export var getDotSize = function getDotSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isActive = _ref.isActive,
    isNext = _ref.isNext,
    isPrevious = _ref.isPrevious;
  if (isActive) {
    return '12px';
  } else if (isNext || isPrevious) {
    return '4px';
  }
  return '8px';
};
//# sourceMappingURL=getDotSize.js.map